angular.module('ordersSubscript', ['ngRoute', 'ngResource', 'core', 'core.auth', 'core.env', 'pascalprecht.translate']);


// WEBPACK FOOTER //
// ./src/app/subscription/orders-subscript.module.js